import { render, staticRenderFns } from "./updateRankingModal.vue?vue&type=template&id=5b087494&scoped=true"
import script from "./updateRankingModal.vue?vue&type=script&lang=js"
export * from "./updateRankingModal.vue?vue&type=script&lang=js"
import style0 from "./updateRankingModal.vue?vue&type=style&index=0&id=5b087494&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b087494",
  null
  
)

export default component.exports